import React, { useEffect } from 'react';
import { Calendar } from 'primereact/calendar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
import { Toast } from 'primereact/toast';
import { Checkbox } from 'primereact/checkbox';
import { RadioButton } from 'primereact/radiobutton';
import { ScrollPanel } from 'primereact/scrollpanel';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { API_Root } from "../../globalState";
import axios from 'axios'
import { useRef } from 'react';
import { TripReview } from './TripReview';
import { AddVehicle } from './vehicle/AddVehicle';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { clone } from 'structured-clone';
import { VehicleInfoLite, vehicleInfoIsComplete } from './vehicle/VehicleInfoLite';
import { TripLocation } from './location/Location';
import { formatMatchOption, MAX_MATCH_OPTIONS } from './matchOption';
import {
    ceilToThirtyMinutes,
    dateTimeFromDateAndTime,
    endOfScheduleDay,
    hasScheduleSlot,
    maxPickupDateTime,
    minDeliveryDateTime,
    startOfDay,
    timesForDate,
} from './scheduleWindows';
import './AddSingleVehicle.css';

// Chase origin is a place, not a pickup/delivery role, so a later swap does not retarget it.
// An untouched choice defaults to the current pickup. A choice that no longer matches either place is unset.
function chaseOriginPlace(fromLoc, toLoc, selectedPlaceId, touched) {
    const fromId = fromLoc?.place_id;
    const toId = toLoc?.place_id;
    if (!fromId || !toId) {
        return null;
    }
    if (fromId === toId) {
        return fromId;
    }
    if (selectedPlaceId === fromId || selectedPlaceId === toId) {
        return selectedPlaceId;
    }
    return touched ? null : fromId;
}

function placeTitle(loc) {
    const name = (loc?.name || '').trim();
    const address = (loc?.formatted_address || '').trim();
    return name || address || 'Selected location';
}

export const AddSingleVehicle = (props) => {
    const [tripId, setTripId] = React.useState(0);
    const [distance, setDistance] = React.useState();
    const [deliverytime, setDeliveryTime] = React.useState('');
    const [pickupDate, setPickupDate] = React.useState('');
    const [pickupTime, setPickupTime] = React.useState('');
    const [contactname, setContactName] = React.useState('');
    const [contactphone, setContactPhone] = React.useState('');
    const [sourceContactName, setSourceContactName] = React.useState('');
    const [sourceContactPhone, setSourceContactPhone] = React.useState('');
    const [dealNumber, setDealNumber] = React.useState('');
    const [roundTrip, setRoundTrip] = React.useState(false);
    const [fromTime, setFromTime] = React.useState('');
    const [toTime, setToTime] = React.useState('');
    const [customNotes, setCustomNotes] = React.useState('');
    const [selNotes, setSelNotes] = React.useState([]);
    const [allNotes, setAllNotes] = React.useState([]);
    const [vehicleInfo, setVehicleInfo] = React.useState(null);
    const [fromLocation, setFromLocation] = React.useState();
    const [toLocation, setToLocation] = React.useState();
   const [showValidation, setShowValidation] = React.useState(false);
    const [messages, setMessages] = React.useState([]);
    const [tripToSave, setTripToSave] = React.useState({});
    const [showSaveConfirm, setShowSaveConfirm] = React.useState(false);
    const [vehicleTypes, setVehicleTypes] = React.useState([]);
    const [init, setInit] = React.useState(false);
    const [matchedTrips, setMatchedTrips] = React.useState([]);
    const [selectedTrip, setSelectedTrip] = React.useState();
    const [canProceed1, setCanProceed1] = React.useState(false);
    const [canProceed2, setCanProceed2] = React.useState(false);
    const [currentStep, setCurrentStep] = React.useState(1);
    const [addingToTrip, setAddingToTrip] = React.useState(false);
    const [recentLocations, setRecentLocations] = React.useState([]);
    const [showRecentLocations, setShowRecentLocations] = React.useState(false);
    const [recentLocationNum, setRecentLocationNum] = React.useState(0);
    const [returnVehicleInfo, setReturnVehicleInfo] = React.useState(null);
    const [returnOption, setReturnOption] = React.useState(0);
    const [chaseOriginPlaceId, setChaseOriginPlaceId] = React.useState(null);
    const [chaseOriginTouched, setChaseOriginTouched] = React.useState(false);

    const toast = useRef(null);
    const stepperRef = useRef(null);

    const checkMatchedTrips = () => {
        if (!distance) {
            return;
        }

        var dto = buildSaveDTO();
        var apiUrl = `${API_Root}api/trip/GetTripMatches`;
        axios.put(apiUrl, dto).then((values) => {
            var dt = (values.data || []).slice(0, MAX_MATCH_OPTIONS);
            setMatchedTrips(dt);
            setSelectedTrip(0);

            if (!dt || dt.length == 0) {
                setCurrentStep(3);
            }
            else {
                setCurrentStep(2);
            }
        });
    }

    const getPorterNotesList = () => {
        var apiUrl = `${API_Root}api/trip/GetAllPorterNotes`;
        axios.get(apiUrl).then((values) => {
            console.log('porter notes', values.data);
            setAllNotes(values.data);
        });
    }

    const getRecentLocations = (id) => {

        var apiUrl = `${API_Root}api/dealership/getRecentLocations?id=${id}`;
        axios.get(apiUrl).then((values) => {
            console.log('recent locations', values.data);
            let d = values.data;
            let locs = [];
            d.map((loc, i) => {
                locs.push({
                    id: loc.id,
                    name: loc.dealershipName,
                    formatted_address: `${loc.streetAddress}, ${loc.city}, ${loc.stateAbbr} ${loc.zipCode}`,
                    place_id: loc.googlePlaceId,
                    geometry: {
                        location: {
                            lat: loc.lat,
                            lng: loc.lon
                        }
                    }
                });
            });
            setRecentLocations(locs);
        });

    }

    const getDealership = (id) => {
        var apiUrl = `${API_Root}api/dealership/get?id=${id}`;
        axios.get(apiUrl).then((values) => {
            let dealer = values.data;
            let dealerPlace = {
                name: dealer.dealershipName,
                formatted_address: `${dealer.streetAddress}, ${dealer.city}, ${dealer.stateAbbr} ${dealer.zipCode}`,
                place_id: dealer.googlePlaceId,
                geometry: {
                    location: {
                        lat: dealer.lat,
                        lng: dealer.lon
                    }
                },
                contactName: props.userName,
                contactNumber: props.userPhone
            };

            if (!fromLocation || !fromLocation.place_id) {
                console.log('setting dealership from');
                setFromLocation(dealerPlace);
            }
        });
    }

    const setInitialSource = () => {
        getDealership(props.dealershipId);
        getRecentLocations(props.dealershipId);
    }

    const formatDateTime = (dt) => {
        var d = new Date(dt);
        return d.toLocaleDateString('en-US', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        });
    };

    const getDistanceInfo = (p1, p2) => {
        var apiUrl = `${API_Root}api/trip/GetDistanceInfo`;
        var request = {
            sourceId: p1,
            destinationId: p2
        };

        axios.post(apiUrl, request).then((value) => {
            setDistance(value.data);
        });
    }

    const getMessages = () => {
        if (messages.length > 0) {
            return <>
                <div>Please correct the following issues before saving</div>
                <div>
                    <ul className="text-red-400">
                        {messages.map((m) => <li>{m}</li>)}
                    </ul>
                </div>
            </>
        }
        else {
            return <></>;
        }
    }

    const buildSaveDTO = () => {

        try {
            var deliveryDateTime = null;
            var deliveryDateTimeEnd = null;
            console.log("date", deliverytime, "time", fromTime);

            if ((typeof deliverytime.toDateString) == "function" && fromTime.length > 0) {
                deliveryDateTime = dateTimeFromDateAndTime(deliverytime, fromTime);
                deliveryDateTimeEnd = dateTimeFromDateAndTime(deliverytime, toTime || fromTime);
            }
            var vehicleArray = [];

            const originPlaceId = chaseOriginPlace(fromLocation, toLocation, chaseOriginPlaceId, chaseOriginTouched);
            const chaseOriginReady = returnOption !== 0 || !!originPlaceId;
            // Chase starts and ends at the chosen place. The step-1 vehicle still runs pickup to delivery.
            // Matching and add-to-existing still expect pickup at stop 0. Reorder only for a new trip save.
            const chaseFromDelivery = currentStep === 4
                && returnOption === 0
                && !!originPlaceId
                && originPlaceId === toLocation?.place_id
                && originPlaceId !== fromLocation?.place_id;
            const routeLocations = chaseFromDelivery
                ? [toLocation, fromLocation, clone(toLocation)]
                : [fromLocation, toLocation, clone(fromLocation)];

            if (returnOption === 1) {
                vehicleInfo.fromLocation = 0;
                vehicleInfo.toLocation = 1;

                returnVehicleInfo.fromLocation = 1;
                returnVehicleInfo.toLocation = 2;

                vehicleArray = [vehicleInfo, returnVehicleInfo];
            }
            else if (returnOption === 2) {
                vehicleInfo.fromLocation = 0;
                vehicleInfo.toLocation = 2;
                vehicleArray = [vehicleInfo];
            }
            else if (chaseFromDelivery) {
                vehicleInfo.fromLocation = 1;
                vehicleInfo.toLocation = 2;
                vehicleArray = [vehicleInfo];
            }
            else {
                vehicleInfo.fromLocation = 0;
                vehicleInfo.toLocation = 1;
                vehicleArray = [vehicleInfo];
            }

            var trip = {
                id: selectedTrip > 0 ? selectedTrip : (tripId ?? 0),
                dealershipId: props.dealershipId,
                createdBy: props.userId,
                TripVehicles: vehicleArray,
                estimatedMiles: distance?.miles ?? 0,
                estimatedHours: distance?.minutes ?? 0,
                contactName: contactname,
                contactNumber: contactphone,
                requestedDeliveryDateTime: deliveryDateTime,
                pickupDateTime: (pickupDate && pickupTime) ? dateTimeFromDateAndTime(pickupDate, pickupTime) : null,
                estimatedDistance: "",
                estimatedDuration: "",
                roundTrip: roundTrip,
                requestedDeliveryDateTimeEnd: deliveryDateTimeEnd,
                sourceContactName: sourceContactName,
                sourceContactNumber: sourceContactPhone,
                dealNumber: dealNumber,
                porterNotes: customNotes,
                TripPorterNotes: selNotes.map((n) => { return { noteId: n } })
            };

            var dto = {
                step: currentStep,
                trip: trip,
                chaseOriginReady: chaseOriginReady,
                distances: distance && fromLocation?.place_id && toLocation?.place_id
                    ? [
                        { ...distance, fromPlaceId: fromLocation.place_id, toPlaceId: toLocation.place_id },
                        { ...distance, fromPlaceId: toLocation.place_id, toPlaceId: fromLocation.place_id },
                    ]
                    : [],
                locations: routeLocations,
                selectedTrip: selectedTrip
            };

            props.onDataUpdate(dto);

            if (fromLocation && fromLocation.place_id && toLocation && toLocation.place_id && vehicleInfoIsComplete(vehicleInfo)) {
                setCanProceed1(true);
            } else {
                setCanProceed1(false);
            }

            console.log("selectedTrip", selectedTrip);
            setCanProceed2(selectedTrip !== undefined && selectedTrip !== null);

        }
        catch (e) {
            console.log('Unable to build DTO', e);
        }


        return dto;
    }

    const addToExistingTrip = () => {
        var dto = buildSaveDTO();
        if (!dto || !selectedTrip) {
            return;
        }
        dto.trip.id = selectedTrip;
        setAddingToTrip(true);
        var apiUrl = `${API_Root}api/trip/AddVehicleToTrip`;
        axios.post(apiUrl, dto).then((values) => {
            if (values.data === true) {
                toast.current.show({ severity: 'success', summary: 'Added to trip', detail: 'This vehicle was added to the existing delivery.', life: 3000 });
                props.onCreated();
            } else {
                toast.current.show({ severity: 'error', summary: 'Could not add', detail: 'Please try again.', life: 4000 });
            }
        }).catch(() => {
            toast.current.show({ severity: 'error', summary: 'Could not add', detail: 'Please try again.', life: 4000 });
        }).finally(() => {
            setAddingToTrip(false);
        });
    }

    const completeSave = () => {
        let t = tripToSave;
        //t.trip.requestedDeliveryDateTime = stripTimeZone(t.trip.requestedDeliveryDateTime);
        //t.trip.requestedDeliveryDateTimeEnd = stripTimeZone(t.trip.requestedDeliveryDateTimeEnd);

        //if (t.trip.pickupDateTime) {
        //   t.trip.pickupDateTime = stripTimeZone(t.trip.pickupDateTime);
        //}

        var apiUrl = `${API_Root}api/trip/SaveTripv2`;
        axios.post(apiUrl, t).then((values) => {
            console.log('save trip', values.data);
            if (values.data === true) {
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Trip successfully created', life: 3000 });
            }
            else {
                toast.current.show({ severity: 'error', summary: 'Error', detail: 'Trip could not be created', life: 3000 });
            }
            setShowSaveConfirm(false);
            props.onCreated();
        });
    }

    const oneWayMinutes = distance?.minutes ?? 0;
    const minDeliveryDt = React.useMemo(
        () => ceilToThirtyMinutes(minDeliveryDateTime(oneWayMinutes)),
        [oneWayMinutes]
    );
    const hasDeliveryDate = deliverytime && typeof deliverytime.getFullYear === 'function';
    const computedFromTimes = hasDeliveryDate ? timesForDate(deliverytime, minDeliveryDt) : [];
    const maxPickupDt = React.useMemo(() => {
        if (!hasDeliveryDate) {
            return null;
        }
        const deliveryDt = fromTime
            ? dateTimeFromDateAndTime(deliverytime, fromTime)
            : endOfScheduleDay(deliverytime);
        return maxPickupDateTime(deliveryDt, oneWayMinutes);
    }, [hasDeliveryDate, deliverytime, fromTime, oneWayMinutes]);
    const hasPickupDate = pickupDate && typeof pickupDate.getFullYear === 'function';
    const computedPickupTimes = hasPickupDate ? timesForDate(pickupDate, new Date(), maxPickupDt || undefined) : [];
    const fromTimeIndex = computedFromTimes.findIndex((t) => t.value === fromTime);
    const computedToTimes = fromTimeIndex >= 0 ? computedFromTimes.slice(fromTimeIndex + 1) : [];
    const pickupEnabled = !!maxPickupDt && hasScheduleSlot(new Date(), maxPickupDt);

    const getMinDate = () => minDeliveryDt;

    const selectFromTime = (val) => {
        setFromTime(val);
        const ind = computedFromTimes.findIndex((t) => t.value === val);
        const rest = ind >= 0 ? computedFromTimes.slice(ind + 1) : [];
        setToTime(rest[0]?.value ?? '');
    };

    const deliveryDateSelected = (dt) => {
        setDeliveryTime(dt);
        setFromTime('');
        setToTime('');
    };

    const pickupDateSelected = (dt) => {
        setPickupDate(dt);
        setPickupTime('');
    };

    const onNotesChange = (e) => {
        let _notes = [...selNotes];

        if (e.checked)
            _notes.push(e.value);
        else
            _notes.splice(_notes.indexOf(e.value), 1);

        setSelNotes(_notes);
    }

    const switchLocations = () => {
        let from = clone(fromLocation);
        let to = clone(toLocation);

        setFromLocation(to);
        setToLocation(from);
    }

    useEffect(() => {
    }, [init]);

    useEffect(() => {
        buildSaveDTO();
    }, [vehicleInfo, contactname, contactphone, deliverytime, fromTime, pickupDate, pickupTime, toTime, sourceContactName, sourceContactPhone, dealNumber, customNotes, selNotes, fromLocation, toLocation, selectedTrip, currentStep, returnOption, returnVehicleInfo, chaseOriginPlaceId, chaseOriginTouched]);

    useEffect(() => {
        if (fromLocation && toLocation && fromLocation.place_id && toLocation.place_id) {
            getDistanceInfo(fromLocation.place_id, toLocation.place_id);
        }
    }, [fromLocation, toLocation]);

    useEffect(() => {
        if (!hasDeliveryDate) {
            return;
        }
        if (startOfDay(deliverytime) < startOfDay(minDeliveryDt) || computedFromTimes.length === 0) {
            setDeliveryTime('');
            setFromTime('');
            setToTime('');
            return;
        }
        if (fromTime && !computedFromTimes.some((t) => t.value === fromTime)) {
            setFromTime('');
            setToTime('');
        }
    }, [oneWayMinutes, deliverytime]);

    useEffect(() => {
        if (!hasPickupDate) {
            return;
        }
        const pickupTooEarly = startOfDay(pickupDate) < startOfDay(new Date());
        const pickupTooLate = maxPickupDt ? startOfDay(pickupDate) > startOfDay(maxPickupDt) : !hasDeliveryDate;
        if (pickupTooEarly || pickupTooLate || computedPickupTimes.length === 0) {
            setPickupDate('');
            setPickupTime('');
            return;
        }
        if (pickupTime && !computedPickupTimes.some((t) => t.value === pickupTime)) {
            setPickupTime('');
        }
    }, [pickupDate, pickupTime, fromTime, deliverytime, oneWayMinutes]);

    const getDealNumberClass = () => {
        return (dealNumber) ? "w-12rem text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full" :
            "w-12rem text-base text-color surface-overlay p-2 border-1 border-solid border-round appearance-none outline-none focus:border-primary w-full border-red-400";
    }

    const getToTimeClass = () => {
        return (toTime) ? "ml-2" : "ml-2 border-red-400";
    }

    const getFromTimeClass = () => {
        return (fromTime) ? "ml-2" : "ml-2 border-red-400";
    }

    const getDeliveryDateClass = () => {
        return (deliverytime) ? "w-10rem" : "w-10rem border-red-400";
    }

    const getDistanceTemplate = () => {
        if (distance) {
            return <span className="font-semibold font-italic text-sm">{distance.distance} / {distance.duration}</span>;
        }
        return "";
    }

    if (!init) {
        console.log("init");
        getPorterNotesList();
        setInitialSource();
        setSourceContactName(props.userName);
        setSourceContactPhone(props.userPhone);
        setInit(true);
    }

    const getHoursDisplay = (mins) => {
        if (mins) {
            let hours = Math.floor(mins / 60);
            let minutes = Math.floor(mins % 60);
            return `${hours} hrs, ${minutes} mins`;
        }
        else {
            return '';
        }
    }

    const formatMiles = (number) => {
        if (number) {
            return `${number.toLocaleString()} miles`;
        }
        else {
            return '';
        }
    }

    const setVehicleInformation = (veh) => {
        setVehicleInfo(veh);
    }

    const chooseRecentLocation = (i) => {
        setRecentLocationNum(i);
        setShowRecentLocations(true);
    }

    const selectRecentLocation = (i) => {
        let loc = recentLocations[i];
        console.log('num', recentLocationNum);
        if (recentLocationNum === 1) {
            console.log('recent from');
            setFromLocation(loc);
        }
        else {
            console.log('recent to');
            setToLocation(loc);
        }
        setShowRecentLocations(false);
    }

    const recentLocationTemplate = (l, i) => {
        return <div className="cursor-pointer border-round-xl border-1 m-2 p-2 shadow-2" onClick={() => selectRecentLocation(i)}>
            <div><h5>{l.name}</h5></div>
            <div>{l.formatted_address}</div>
        </div>;
    }

    const stepLabels = ['Vehicle & route', 'Trip options', 'Schedule & notes', 'Return options'];

    const getStepProgress = () => (
        <div className="step-progress">
            {stepLabels.map((label, i) => {
                const stepNum = i + 1;
                let className = 'step-progress-item';
                if (stepNum === currentStep) className += ' active';
                else if (stepNum < currentStep) className += ' complete';
                return <span key={label} className={className}>Step {stepNum}: {label}</span>;
            })}
        </div>
    );

    const getProceedHint = () => {
        if (canProceed1) return null;
        const hints = [];
        if (!vehicleInfoIsComplete(vehicleInfo)) {
            hints.push('Enter the vehicle make and model (VIN is optional; use Unknown or Loaner if the exact vehicle is not known yet)');
        }
        if (!fromLocation?.place_id) hints.push('Select a pickup location');
        if (!toLocation?.place_id) hints.push('Select a destination');
        if (hints.length === 0) return null;
        return <div className="step-hint">{hints.join('. ')}.</div>;
    };

    const originPlaceId = chaseOriginPlace(fromLocation, toLocation, chaseOriginPlaceId, chaseOriginTouched);
    const showChaseOrigin = returnOption === 0
        && !!fromLocation?.place_id
        && !!toLocation?.place_id
        && fromLocation.place_id !== toLocation.place_id;

    const chooseChaseOrigin = (placeId) => {
        setChaseOriginTouched(true);
        setChaseOriginPlaceId(placeId);
    };

    const chaseOriginChoice = (placeId, role, loc) => {
        const address = (loc?.formatted_address || '').trim();
        const title = placeTitle(loc);
        return (
            <div className="chase-origin-choice" key={role}>
                <RadioButton
                    value={placeId}
                    name="ChaseOrigin"
                    inputId={'chaseorigin_' + role}
                    onChange={() => chooseChaseOrigin(placeId)}
                    checked={originPlaceId === placeId}
                />
                <label htmlFor={'chaseorigin_' + role} className="ml-2">
                    <span className="font-semibold">{role}</span>
                    <span className="block">{title}</span>
                    {address && address !== title ? <span className="field-hint">{address}</span> : null}
                </label>
            </div>
        );
    };

    return (
        <>
            {getStepProgress()}
            <div style={{ overflow: 'auto', height: 'calc(100% - 40px)' }}>
                <div className="w-full mt-2" style={{ display: currentStep == 1 ? 'block' : 'none' }}>
                    <div className="step-header">
                        <h4 className="step-title">Step 1 — What are you moving, and where?</h4>
                        <p className="step-subtitle">Enter the vehicle details, then choose where it should be picked up and delivered. VIN is optional — use Unknown or Loaner for make and model if the exact vehicle is not known yet. Your dealership is usually the starting point.</p>
                    </div>
                    <VehicleInfoLite onUpdate={(veh) => setVehicleInformation(veh)}></VehicleInfoLite>

                    <div className="grid w-full p-0 mt-3">
                        <div className="col-12 md:col-6">
                            <p className="location-label">Pickup location</p>
                            <Button link label="Choose from recent locations" icon="pi pi-history" className="p-0 mb-1" onClick={() => chooseRecentLocation(1)} />
                        </div>
                    </div>
                    <TripLocation
                        defaultValue={fromLocation}
                        onChange={(loc) => setFromLocation(loc)}
                        readonly={false}>
                    </TripLocation>
                    <div className="grid p-0 m-0 w-full mt-3">
                        <div className="col-12 md:col-6">
                            <p className="location-label mt-2">Delivery location</p>
                            <Button link label="Choose from recent locations" icon="pi pi-history" className="p-0 mb-1" onClick={() => chooseRecentLocation(2)} />
                        </div>
                        <div className="col-12 md:col-6 text-left md:text-right">
                            <Button label="Swap pickup and delivery" link={true} className="p-0 mt-1" icon="pi pi-sort-alt" onClick={() => switchLocations()} />
                        </div>
                    </div>
                    <TripLocation
                        defaultValue={toLocation}
                        onChange={(loc) => setToLocation(loc)}
                        readonly={false}>
                    </TripLocation>
                    {distance && (
                        <div className="step-hint-info mt-2">
                            Estimated drive: {getDistanceTemplate()}
                        </div>
                    )}
                    {canProceed1 && !distance ? (
                        <div className="step-hint-info mt-2">Getting drive time so we can score nearby trips…</div>
                    ) : null}
                    {getProceedHint()}
                    <div className="w-full grid mt-3">
                        <div className="col-12 text-right">
                            <Button label="Next: Trip options" icon="pi pi-arrow-right" iconPos="right" disabled={!canProceed1 || !distance} onClick={() => checkMatchedTrips()} />
                        </div>
                    </div>
                </div>
                <div className="w-full mt-2" style={{ display: currentStep == 2 ? 'block' : 'none' }}>
                    <div className="step-header">
                        <h4 className="step-title">Step 2 — New trip or add to existing?</h4>
                        <p className="step-subtitle">Adding to an existing trip uses that trip’s schedule and notes. You will not need steps 3 or 4.</p>
                    </div>
                    <div key={'tripselect_new'} className={'trip-option-card' + (selectedTrip === 0 ? ' selected' : '')}>
                        <div className="trip-option-head">
                            <RadioButton
                                value={0}
                                name='TripSelect'
                                inputId={'tripselect_new'}
                                onChange={(e) => setSelectedTrip(0)}
                                checked={selectedTrip === 0}
                            />
                            <div className="trip-option-body">
                                <label htmlFor={'tripselect_new'} className="trip-option-title">Create a new delivery</label>
                                <p className="trip-option-why mb-0">Schedule this vehicle on its own trip.</p>
                            </div>
                        </div>
                    </div>
                    {matchedTrips.map((m, i) => {
                        const opt = formatMatchOption(m, i === 0);
                        const selected = selectedTrip === m.matchedTrip.id;
                        return (
                            <div key={'tripselect_' + i} className={'trip-option-card' + (selected ? ' selected' : '')}>
                                <div className="trip-option-head">
                                    <RadioButton
                                        value={m.matchedTrip.id}
                                        name='TripSelect'
                                        inputId={'tripselect_' + i}
                                        onChange={(e) => setSelectedTrip(e.value)}
                                        checked={selected}
                                    />
                                    <div className="trip-option-body">
                                        <div className="trip-option-title-row">
                                            <label htmlFor={'tripselect_' + i} className="trip-option-title">
                                                {opt.title}
                                            </label>
                                            {opt.recommended ? <span className="trip-option-badge">Recommended</span> : null}
                                        </div>
                                        {opt.route ? <div className="trip-option-route">{opt.route}</div> : null}
                                        <div className="trip-option-chips">
                                            {opt.chips.map((chip) => (
                                                <span key={chip.label} className={'trip-option-chip ' + chip.tone}>{chip.label}</span>
                                            ))}
                                        </div>
                                        {opt.why ? <p className="trip-option-why">{opt.why}</p> : null}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    <div className="w-full grid mt-3">
                        <div className="col-12 md:col-6">
                            <Button label="Back" severity="secondary" icon="pi pi-arrow-left" onClick={() => setCurrentStep(1)} />
                        </div>
                        <div className="col-12 md:col-6 text-left md:text-right">
                            {selectedTrip > 0 ? (
                                <Button label={addingToTrip ? 'Adding…' : 'Add to this trip'} icon="pi pi-check" iconPos="right" disabled={!canProceed2 || addingToTrip} onClick={() => addToExistingTrip()} />
                            ) : (
                                <Button label="Next: Schedule" icon="pi pi-arrow-right" iconPos="right" disabled={!canProceed2} onClick={() => setCurrentStep(3)} />
                            )}
                        </div>
                    </div>
                </div>
                <div className="w-full mt-2" style={{ display: currentStep == 3 ? 'block' : 'none' }}>
                    <div className="step-header">
                        <h4 className="step-title">Step 3 — When should it arrive?</h4>
                        <p className="step-subtitle">Set the delivery window and any notes for the driver. Deal number is required for tracking.</p>
                    </div>
                    <div className="field flex flex-column">
                        <label htmlFor="dealnumber">Deal number <span className="required-mark">*</span></label>
                        <input id="dealnumber"
                            value={dealNumber}
                            onChange={(e) => setDealNumber(e.target.value)}
                            placeholder="Sales deal or RO number"
                            className={getDealNumberClass()} />
                        <small className="field-hint">Used to link this move to your sales or service records.</small>
                    </div>
                    <div className="w-full grid">
                        <div className="flex flex-column col-12 md:col-7">
                            <div className="field mt-1">
                                <label htmlFor="deliverytime">Requested delivery window <span className="required-mark">*</span></label>
                                <div className="flex flex-wrap align-items-center gap-2">
                                    <Calendar minDate={getMinDate()} value={deliverytime} onChange={(e) => deliveryDateSelected(e.value)} placeholder="Select date" inputClassName={getDeliveryDateClass()} />
                                    <Dropdown value={fromTime} onChange={(e) => selectFromTime(e.value)} options={computedFromTimes} optionLabel="value"
                                        placeholder="From" className={getFromTimeClass()} />
                                    <Dropdown value={toTime} onChange={(e) => setToTime(e.value)} options={computedToTimes} optionLabel="value"
                                        placeholder="To" className={getToTimeClass()} />
                                </div>
                                <small className="field-hint">When the vehicle must be delivered. Earliest time is now plus the drive time to the last stop before returning home, plus 30 minutes{distance ? ` (${minDeliveryDt.toLocaleString('en-US', { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' })})` : ''}.</small>
                            </div>
                        </div>
                        <div className="field flex flex-column col-12 md:col-5">
                            <div className="field mt-1">
                                <label htmlFor="pickuptime">Pickup available (optional)</label>
                                <div className="flex flex-wrap align-items-center gap-2">
                                    <Calendar minDate={new Date()} maxDate={maxPickupDt || undefined} disabled={!pickupEnabled} value={pickupDate} onChange={(e) => pickupDateSelected(e.value)} placeholder="Select date" inputClassName="w-10rem" />
                                    <Dropdown value={pickupTime} onChange={(e) => setPickupTime(e.value)} options={computedPickupTimes} optionLabel="value"
                                        placeholder="Time" disabled={!hasPickupDate} />
                                </div>
                                <small className="field-hint">When the driver can pick up the vehicle. Must be no earlier than now and no later than the requested delivery time minus the estimated drive time plus 30 minutes.</small>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-column">
                        <div className="flex flex-wrap justify-content-left">
                            <label htmlFor="">Standard notes for driver</label>
                            <ScrollPanel style={{ width: '100%', height: '80px' }}>
                                {allNotes.map((n, i) => {
                                    return (<div key={i}>
                                        <Checkbox
                                            value={n.id}
                                            onChange={onNotesChange}
                                            checked={selNotes.includes(n.id)} />
                                        <span className="ml-2">{n.note}</span>
                                    </div>);
                                })
                                }
                            </ScrollPanel>
                            <div className="field">
                                <label htmlFor="customnotes">Custom note</label>
                                <div>
                                    <InputTextarea autoResize
                                        id="customnotes"
                                        value={customNotes}
                                        onChange={(e) => setCustomNotes(e.target.value)}
                                        rows={5}
                                        cols={80}
                                        placeholder="Any special instructions for the driver..."
                                        className="w-full"
                                        style={{ minHeight: '7rem' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="flex pt-4 justify-content-between">
                        <Button label="Back" severity="secondary" icon="pi pi-arrow-left" onClick={() => setCurrentStep(matchedTrips.length > 0 ? 2 : 1)} />
                        {selectedTrip === 0 ? (
                            <Button label="Next: Return options" icon="pi pi-arrow-right" iconPos="right" disabled={!canProceed2} onClick={() => setCurrentStep(4)} />
                        ) : null}
                    </div>
                </div>
                <div className="w-full mt-2" style={{ display: currentStep == 4 ? 'block' : 'none' }}>
                    <div className="step-header">
                        <h4 className="step-title">Step 4 — How should the driver get back?</h4>
                        <p className="step-subtitle">After delivering the vehicle, the driver needs a way to return. Choose the option that fits this move.</p>
                    </div>
                    <div className="flex flex-column">
                        <div className="flex flex-wrap justify-content-left">
                            <ScrollPanel style={{ width: '100%', height: '400px' }}>
                                <div className="trip-option-card mt-1">
                                <RadioButton
                                    value={0}
                                    name='ReturnOption'
                                    inputId={'returnoption_0'}
                                    onChange={(e) => setReturnOption(0)}
                                    checked={returnOption === 0}
                                />
                                <label htmlFor={'returnoption_0'} className="ml-2 font-semibold">Follow vehicle (chase car)</label>
                                <p className="field-hint ml-4 mb-0">A second driver follows in another vehicle to bring the first driver back.</p>
                                {showChaseOrigin ? (
                                    <div className="chase-origin ml-4 mt-3">
                                        <div className="font-semibold">Chase vehicle originates from</div>
                                        <p className="field-hint mb-2">The chase car leaves from this location and comes back here. The vehicle from step 1 still moves from pickup to delivery.</p>
                                        {chaseOriginChoice(fromLocation.place_id, 'Pickup', fromLocation)}
                                        {chaseOriginChoice(toLocation.place_id, 'Delivery', toLocation)}
                                        {!originPlaceId ? <p className="field-hint text-red-400 mb-0">Choose where the chase car starts.</p> : null}
                                    </div>
                                ) : null}
                                </div>
                                <div className="trip-option-card">
                                <RadioButton
                                    value={1}
                                    name='ReturnOption'
                                    inputId={'returnoption_1'}
                                    onChange={(e) => setReturnOption(1)}
                                    checked={returnOption === 1}
                                />
                                <label htmlFor={'returnoption_1'} className="ml-2 font-semibold">Add a return vehicle on this trip</label>
                                <p className="field-hint ml-4 mb-2">Driver delivers one vehicle and drives another back — no chase car needed.</p>
                                <div hidden={ returnOption !== 1 } >
                                <VehicleInfoLite onUpdate={(veh) => setReturnVehicleInfo(veh)}></VehicleInfoLite>
                                </div>
                                </div>
                                <div className="trip-option-card">
                                <RadioButton
                                    value={2}
                                    name='ReturnOption'
                                    inputId={'returnoption_2'}
                                    onChange={(e) => setReturnOption(2)}
                                    checked={returnOption === 2}
                                />
                                <label htmlFor={'returnoption_2'} className="ml-2 font-semibold">This vehicle is making a round trip</label>
                                <p className="field-hint ml-4 mb-0">The same vehicle will be driven back to the starting location by the same driver.</p>
                                </div>
                            </ScrollPanel>
                        </div>
                    </div>
                    <div className="flex pt-4 justify-content-between">
                        <Button label="Back" severity="secondary" icon="pi pi-arrow-left" onClick={() => setCurrentStep(3)} />
                    </div>
                </div>
            </div>
            <Toast ref={toast} />
            <Dialog header="Validation" visible={showValidation} style={{ width: '30vw' }} breakpoints={{ '960px': '75vw', '641px': '95vw' }} onHide={() => setShowValidation(false)}>
                {getMessages()}
                <div className="col-12 md:col-5 text-right">
                    <Button label="Close" onClick={() => setShowValidation(false)} />
                </div>
            </Dialog>
            <Dialog header="Select a recent location" visible={showRecentLocations} style={{ width: '60vw' }} breakpoints={{ '960px': '85vw', '641px': '95vw' }} onHide={() => setShowRecentLocations(false)}>
                {recentLocations.map((t, i) => {
                    return recentLocationTemplate(t, i);
                })}

            </Dialog>
        </>);

};